import i18n from "i18next";
import { useState } from "react";

import { VirtualAcquirerCreateForm } from "src/app/features/Acquirer/components/forms/VirtualAcquirerCreateForm";
import { ActionBar } from "../../../../components/ActionBar/ActionBar";
import { PageTitle } from "../../../../components/AppLayout/components/Content/components";
import { FPage, FPageContent, FPageHeader } from "../../../../components/AppLayout/components/FPageLayout";
import { PrimaryButton } from "../../../../components/Buttons/components/ActionButton";
import { BackButton } from "../../../../components/FeatureButtons/BackButton";
import { ResourceName } from "../../../../core/router/config/ResourceName";
import { BASE_PATH } from "../../../../core/router/types/routerTypes";

export const VirtualAcquirerCreateFormPage = () => {
    const [runSubmit, setRunSubmit] = useState(0);
    const triggerFormSubmit = () => setRunSubmit(runSubmit + 1);

    return (
        <FPage>
            <FPageHeader>
                <PageTitle translationKey="page.title.acquirersVirtualCreateFormPage" />
                <ActionBar>
                    <PrimaryButton name="continue_button" disabled={false} onClick={triggerFormSubmit}>
                        {i18n.t("button.continue")}
                    </PrimaryButton>
                    <BackButton isDisabled={false} url={`${BASE_PATH}/${ResourceName.ACQUIRER}`} />
                </ActionBar>
            </FPageHeader>
            <FPageContent>
                <VirtualAcquirerCreateForm runSubmit={runSubmit} />
            </FPageContent>
        </FPage>
    );
};
